import {
  Button,
  ExpandablePanel,
  ExpandablePanelBody,
  ExpandablePanelHeader,
  TextField,
  Typography,
  DocumentList,
} from "@king-ict/eupisi-ui/components";
import { Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import InitialConversationQuestionDataItem from "../../../models/Request/InitialConversationQuestionDataItem";
import InitialConversationQuestionGroup from "../../../models/Request/InitialConversationQuestionGroup";
import { useInitialConversationDocuments } from "../../Request/InitialConversationStep/useInitialConversationDocuments";
import styles from "./RequestDetailsPage.module.scss";

interface Props {
  emptyValue: string;
  questionGroups: InitialConversationQuestionGroup[];
  moveToSpecificStep?: (step: number, substep?: number) => void;
  onExpandablePanelClick?: () => void;
}

export default function InitialConversationDetails({
  emptyValue,
  questionGroups,
  moveToSpecificStep,
  onExpandablePanelClick,
}: Props) {
  const { t } = useTranslation();
  const { handleDownloadDocument } = useInitialConversationDocuments();

  const renderQuestionGroups = () => {
    if (questionGroups.length > 0) {
      return questionGroups.map((questionGroup) => {
        return (
          <Row className={styles.rowHeadingSpace} key={questionGroup.id}>
            <Col md={12}>
              <ExpandablePanel clickableHeader>
                <ExpandablePanelHeader small className={styles.subPanel}>
                  {questionGroup.name}
                </ExpandablePanelHeader>
                <ExpandablePanelBody className={styles.subPanel}>
                  <Row>
                    <Col md={10}></Col>
                    {moveToSpecificStep && (
                      <Col md={2}>
                        <Button
                          size="sm"
                          outline
                          onClick={() =>
                            moveToSpecificStep(4, questionGroup.id - 1)
                          }
                        >
                          {t("common.edit")}
                        </Button>
                      </Col>
                    )}
                  </Row>
                  {renderQuestions(questionGroup.questionsData)}
                </ExpandablePanelBody>
              </ExpandablePanel>
            </Col>
          </Row>
        );
      });
    }
  };

  const renderQuestions = (
    questions: InitialConversationQuestionDataItem[]
  ) => {
    const result = questions
      .map((q, i) => {
        return i % 3 === 0 ? questions.slice(i, i + 3) : null;
      })
      .filter((result) => {
        return result;
      });

    return (
      <>
        {result.map((result, index) => {
          return (
            <Row key={index} className={styles.rowSpace}>
              {result?.map((item) => (
                <Col md={4} key={item.questionGroupQuestionId}>
                  {item.documents && item.documents?.length > 0 ? (
                    <>
                      <Typography variant="smallHeading">
                        {t("documentUpload.additionalDocumentationList")}
                      </Typography>
                      <DocumentList
                        documents={item?.documents || []}
                        onDocumentClick={handleDownloadDocument}
                        removable={false}
                        fullWidth
                      />
                    </>
                  ) : (
                    <TextField
                      type="text"
                      label={item.questionName}
                      value={item.answer || emptyValue}
                      plaintext
                    />
                  )}
                </Col>
              ))}
            </Row>
          );
        })}
      </>
    );
  };

  return (
    <>
      <Row className={styles.rowSpace}>
        <Col md={12}>
          <ExpandablePanel clickableHeader>
            <ExpandablePanelHeader onClick={onExpandablePanelClick}>
              {t("requestReviewStep.initialConversation")}
            </ExpandablePanelHeader>
            <ExpandablePanelBody>{renderQuestionGroups()}</ExpandablePanelBody>
          </ExpandablePanel>
        </Col>
      </Row>
    </>
  );
}
